import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Card } from "../components/Layout";
import bookingApi from "../service/bookingApi";
import { TiTickOutline } from "react-icons/ti";

const Success = () => {
  const params = useParams();
  const id = params.id;
  const navigate = useNavigate();

  useEffect(() => {
    console.log(id);
    const confirmBooking = async () => {
      if (id) {
        try {
          const response = await bookingApi.createBooking(id);
          console.log("Booking confirmed:", response);
          if (response?.customerId) {
            setTimeout(() => {
              navigate("/questionnaire", {
                state: { customerId: response.customerId },
              });
            }, 1000);
          } else {
            console.error("Customer ID is missing in the response");
          }
        } catch (error) {
          console.error("Error confirming booking:", error);
        }
      }
    };

    confirmBooking();
  }, [id]);

  return (
    <Container>
      <Card style={{ textAlign: "center", padding: "25px" }}>
        <h1>🎉 Betaling gennemført!</h1>
        <div style={{ fontSize: "70px", color: "#018D66", fontWeight: "bold" }}>
          <TiTickOutline />
        </div>
        <div
          style={{
            color: "#B23A48",
            fontWeight: "bold",
            fontSize: "18px",
            marginTop: "20px",
            padding: "15px",
            borderRadius: "10px",
            backgroundColor: "#FFE8E8",
            display: "inline-block",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            maxWidth: "90%",
            lineHeight: "1.5",
          }}
        >
          📝 Udfyld venligst følgende spørgsmål for at sikre et problemfrit
          møde.
        </div>
      </Card>
    </Container>
  );
};

export default Success;
